export default __webpack_public_path__ + "static/conference-bca4388a39f511bf7f781c226a270d1b.svg";